import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { messageService } from "../../Services/message.service";
import { globalServices } from "../../Services/global.service";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import SpinnerLoading from "../Common/SpinnerLoading";
import Tooltip from "../Common/Tooltip";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import * as dateHelper from "../../Helpers/DateHelper";
import AsyncSelect from "react-select/async";

const Index = () => {
  const { t: translator } = useTranslation();
  const { userId, roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const { updateLocTab, updateLocName, isMobile, locTenant } = useContext(
    GlobalContext
  );
  const [message, setMessage] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [filters, setFilters] = useState({
    tenantId: 0,
    searchText: "",
    sortName: "Title",
    isAsc: false,
    userId: null,
  });
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  const [update, setUpdate] = useState(new Date());
  const history = useHistory();

  useEffect(() => {
    if (![master, admin, support].includes(Number(roleId))) {
      history.push("/error-page/401");
    } else {
      updateLocName("messages");
      messageService
        .get({
          tenantId: Number(filters.tenantId),
          searchText: filters.searchText,
          sortName: filters.sortName,
          isAsc: filters.isAsc,
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
        })
        .then((res) => {
          setIsLoading(false);
          setMessage(res.data.data);
          setPagination({ ...pagination, totalCount: res.data.totalCount });
        })
        .catch((err) => {
          console.error(err.response);
        });

      updateLocTab(0);
    }
  }, [update, filters]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="id"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const columns = [
    {
      dataField: "title",
      text: translator("Message-View-TableHeader-Title"),
      headerStyle: (colum, colIndex) => {
        return { width: "30%", textAlign: "left" };
      },
    },
    {
      dataField: "text",
      text: translator("Message-View-TableHeader-Text"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "created",
      text: translator("Message-View-TableHeader-Created"),
      formatter: dateTimeFormatter,
    },
  ];

  const addMessage = () => {
    history.push("/addmessage");
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Message-View-Span-MessageView")}</span>
          <button
            className={
              "btn btn-primary float-right" + (isMobile ? " btn-sm" : "")
            }
            onClick={addMessage}
          >
            <span></span>
            <span
              className="icon icon-cancel web-hidden"
              style={{ transform: "rotate(45deg)" }}
            ></span>{" "}
            <span className="mob-hidden">
              {translator("Message-View-AddMessage")}
            </span>
          </button>
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Message-View-Filters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group col-lg-3">
                <label htmlFor="ddlStore">
                  {translator("POS-View-Tenant")}
                </label>
                <AsyncSelect
                  name="tenantId"
                  onChange={(event) => {
                    setTenantObj({
                      id: event.id,
                      label: event.label,
                      value: event.value,
                    });
                    setFilters({ ...filters, tenantId: event.id });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  placeholder={translator("Select-Tenant")}
                  value={tenantObj}
                />
              </div>
              <div className="form-group col-lg-3">
                <label>{translator("Message-View-Search")}</label>{" "}
                <Tooltip text={translator("MessagesTooltip-Msg")} />
                <input
                  name="searchText"
                  type="text"
                  className="form-control"
                  defaultValue={filters.searchText}
                  onChange={handleInputChange}
                />
              </div>
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={message}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Index;
